import React from "react";

import Cta from "../Cta";

export default (props) => (
  <Cta text={props.text} url={props.url} class={props.class} theme={props.className || "light"} />
);
